import logger from 'loglevel'

logger.setDefaultLevel(process.env.RAILS_ENV !== 'production' ? logger.levels.TRACE : logger.levels.INFO)

export default logger
